import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import { BoardHolderService } from './../board/board.holder.service';

@Injectable({
  providedIn: 'root',
})
export class SentryService {
  constructor(private boardHolderService: BoardHolderService) {}

  sendFeedback(name: string, email: string, comments: string) {
    const eventId = Sentry.captureMessage('User Feedback');

    console.log('------ event id:', eventId);
    const userFeedback = {
      event_id: eventId,
      name: name ?? 'No Name',
      email: email ?? 'No Email',
      comments: comments,
    };
    Sentry.captureUserFeedback(userFeedback);
  }
}
